import { t } from "i18next";
import { RestApiResponse } from "../../Models/RestApiResponse";
import { getProjectsAsync } from "../../Services/ProjectsService";
import { notAuthorised } from "../UserAuth/UserAuthActions";
import {
  fetchingProjects,
  getProjectsError,
  getProjectsSuccess,
  setFilter,
} from "./ProjectListActions";
import { ProjectSummary } from "../../Models/ProjectSummary";
import { FilterOptions } from "../../Helpers/Constants";
import dayjs from "dayjs";

export const getProjectsList = (filter?: FilterOptions) => (dispatch: any) => {
  dispatch(fetchingProjects());
  getProjectsAsync().then((response: RestApiResponse) => {
    if (response.statusCode === 401) {
      dispatch(notAuthorised());
    }
    if (response.success) {
      if (response.data.logo) {
        var blob = new Blob([response.data.logo], { type: "image/jpeg" });
        var imageUrl = URL.createObjectURL(blob);
        response.data.logo = imageUrl;
      }

      dispatch(getProjectsSuccess(response.data));

      if (filter) {
        const filtered = filterProjects(response.data, filter);
        dispatch(setFilter(filter, filtered));
      }
    } else {
      const errorCode = response.errorCode
        ? response.errorCode
        : "GetDealerProjectsError";
      dispatch(getProjectsError(errorCode));
    }
  });
};

export const filterProjects = (projectsList: ProjectSummary[], filter: FilterOptions) => {
    switch (filter) {
        case FilterOptions.None: {
            return projectsList;
        }
        case FilterOptions.Name: {
            return projectsList?.sort((a, b) => (a.name < b.name ? -1 : 1));
        }
        case FilterOptions.Country: {
            return projectsList?.sort((a, b) => {
                const countryA = a.country && a.country !== "undefined" ? t("Texts.c" + a.country) : "undefined";
                const countryB = b.country && b.country !== "undefined" ? t("Texts.c" + b.country) : "undefined";
                return countryA.localeCompare(countryB);
            });
        }
        case FilterOptions.Customer: {
            return projectsList?.sort((a, b) => {
                const customerA = a.customer ?? "undefined";
                const customerB = b.customer ?? "undefined";
                return customerA.localeCompare(customerB);
            });
        }
        case FilterOptions.LicenseExpiration: {
            return projectsList?.sort((a, b) => {
                const licenseAExpirationDate = a.licenses ? a.licenses[0].enddate : dayjs().add(100, "year"); // add distant future year to put projects without license expiration date to the end of the list
                const licenseBExpirationDate = b.licenses ? b.licenses[0].enddate : dayjs().add(100, "year");
                return dayjs(licenseAExpirationDate).isBefore(licenseBExpirationDate) ? -1 : 1;
            });
        }
        default:
            return projectsList;
    }
};